import { NewsSection } from './newsSection';
import apiService from '../../../services/apiService';
import NewsListActionCreator from '../../../actions/newsListActionCreator';
import _ from 'lodash';

export type TNewsPaneProps = {
  enabled: boolean;
  maxEntries: number;
};

export function NewsPane(props: TNewsPaneProps) {
  if (!props.enabled) {
    return null;
  }

  return <NewsSection max={props.maxEntries} />;
}

(NewsPane as any).preloadComponentActions = async (contentParams: TNewsPaneProps, params: any) => {
  if (!contentParams.enabled) {
    return Promise.resolve([]);
  }
  return _.flatten(
    await Promise.all([
      new Promise((resolve: any, reject: any) => {
        const loadParams = {
          mode: 'featured',
          limit: contentParams.maxEntries,
          tag: '',
          user: '',
          p: 0
        };
        apiService.getNewsListContent(loadParams, (err, result) => {
          if (err) {
            reject(err);
          } else {
            if (result) {
              resolve([
                NewsListActionCreator.setNewsListContent(result),
                NewsListActionCreator.setNewsListLoading(false)
              ]);
            }
          }
        });
      })
    ])
  );
};
